import ReportHeading from './ReportHeading'

export default ReportHeading
